import { IChannelNotificationResponse } from "@wingspanhq/notifications/dist/lib/interfaces";
import { NotificationType } from "@wingspanhq/notifications/dist/lib/interfaces/notifications";

export const selectorCountOfVisibleNotifications = (
  responses: IChannelNotificationResponse[]
) => {
  return (
    responses.filter(response => {
      // Only count non-dismissable notifications that haven't been dismissed
      // This matches the todo list logic which excludes all dismissable notifications
      return (
        response.type === NotificationType.NonDismissable &&
        !response.isDismissed
      );
    }).length || 0
  );
};
